var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.showsSeek,
      "persistent": "",
      "width": "480"
    }
  }, [_c('v-card', {
    staticClass: "fill-height ma-0 black",
    attrs: {
      "dark": "",
      "tile": "",
      "loading": ""
    }
  }, [_c('v-card-title', [_vm._v(" 참여 대기 중 ")]), _c('v-card-text', [_vm._v(" 참여요청이 발송되었습니다. "), _c('br'), _vm._v(" 관리자 승인 시 참여가 가능합니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }